import React, { Component } from 'react'
import { safeParse } from '../utils';
const Parser = safeParse;
import { 
  ChevronIcon2
} from './SVGIcons';
import OffcanvasForm from './OffcanvasForm';

class App extends Component {
  state = {
    showForm: false
  };

  // Метод для открытия формы
  openForm = () => {
    this.setState({ showForm: true });
  };

  // Метод для закрытия формы
  closeForm = () => {
    this.setState({ showForm: false });
  };

  // Обработчик успешной отправки
  handleFormSuccess = (message) => {
    if (this.props.onSuccess) {
      this.props.onSuccess(message);
    }
  };

  // Обработчик ошибки отправки
  handleFormError = (error) => {
    if (this.props.onError) {
      this.props.onError(error);
    }
  };

  render() {
    const { data, showWindow } = this.props;
    const { showForm } = this.state;
    const { block_cooperation } = data;

    return (
      <>
        <div className='mt-[20px] xl:mt-[30px] tracking-[-0.04em]'>
          <div className='container'>
            <div className='w-full rounded-[15px] bg-[#009EE3] text-white p-[20px] xl:p-[30px] flex flex-col xl:flex-row gap-[20px] xl:gap-0 items-start justify-between'
              style={{
                backgroundImage: `url(${block_cooperation?.fon})`,
                backgroundSize: 'cover'
              }}
            >
              <div className='flex-1'>
                <div className='flex justify-between items-start w-full'>
                  <h2 className='font-medium text-[24px] xl:text-[36px] leading-none'>
                    {Parser(block_cooperation?.title)}
                  </h2>
                  <img className='hidden xl:block' src={data?.slogo} width={50} height={50} alt='logo' />
                </div>
                <div className='flex justify-between items-end mt-[14px]'>
                  <div className='text-white/60 text-[14px] xl:text-[16px]'>
                    <div className='xl:max-w-[437px] leading-none'>
                      {Parser(block_cooperation?.text)}
                    </div>
                  </div>
                  {/* Кнопка Оставить заявку для десктопа */}
                  <div 
                    onClick={this.openForm}
                    className='hidden xl:flex items-center gap-[9px] h-[50px] px-[19px] bg-white text-black rounded-full cursor-pointer whitespace-nowrap hover:bg-gray-100 transition-colors duration-300'
                  >
                    <div>Оставить заявку</div>
                    <ChevronIcon2 stroke="black" />
                  </div>
                </div>
              </div>
              <div className='flex flex-col sm:flex-row items-center justify-center xl:justify-start gap-[5px] flex-none w-full xl:w-auto'>
                <div className='w-[16px] hidden xl:block'></div>
                <img className='w-full sm:w-[223px] h-[130px] sm:h-auto object-cover rounded-[15px]' src={block_cooperation?.img1} alt="coop_1" width={223} height={151} />
                <img className='w-full sm:w-[223px] h-[130px] sm:h-auto object-cover rounded-[15px]' src={block_cooperation?.img2} alt="coop_2" width={223} height={151} />
              </div>
              <div className='flex xl:hidden gap-[10px] items-center w-full'>
                <div onClick={() => showWindow()} className='flex text-[12px] items-center gap-[9px] h-[38px] justify-center flex-1 bg-white text-black rounded-full cursor-pointer whitespace-nowrap hover:bg-gray-100 transition-colors duration-300'>
                  <div>Связаться</div>
                  <ChevronIcon2 stroke="black" />
                </div>
                <img className='block' src={data?.slogo} width={38} height={38} alt='logo' />
              </div>
            </div>
          </div>
        </div>

        {/* Форма обратной связи */}
        <OffcanvasForm
          show={showForm}
          hide={this.closeForm}
          formTitle="Оставить заявку"
          productName="" // Можно передать название товара, если нужно
          onSuccess={this.handleFormSuccess}
          onError={this.handleFormError}
        />
      </>
    );
  }
}

export default App;